<template>
  <div class="d-block"> 
    <div class="barchart-wrapper justify-content-center">

      <div class="row">
        <div class="col-12">
          <div class="legend-container">
            <div class="legend" :class="`legend-${ix}`" v-for="(l, ix) in legends" :key="l">
              <span class="l-icon" :class="`l-icon-${ix}`"></span>
              {{ l }}
            </div>
          </div>
        </div>
        <div class="col-12">

          <div class="border-item" v-for="(m, i) in groupData.slice(0,3)" :key="`column_group_${i}_nd`">
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="respuesta-name">{{ m.groupby }}</div>
              </div>
              <div class="col-12 col-md-9">
                <div class="row justify-content-center">
                  <div class="col-12">
                    <div class="bar-grouped-bars">
                      <div>
                          <div :key="ix" v-for="(column, ix) in m.options" :style="`background-color: ${column.color}; width:${(column.date_one)}%`" class="d-inline-block barra" :class="`barra-group-${legends.indexOf(column.options)}`">
                            <div :style="`color: ${column.color}`" class="porcentaje-stacked porcentaje">{{ column.date_one }}<span class="symbol">%</span></div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <b-collapse :id="kebabCase(pregunta_id)">
          <div class="border-item" v-for="(m, i) in groupData.slice(3, groupData.length)" :key="`column_group_hide_${i}_nd`">
            <div class="row">
              <div class="col-12 col-md-3">
                <div class="respuesta-name">{{ m.groupby }}</div>
              </div>
              <div class="col-12 col-md-9">
                <div class="row justify-content-center">
                  <div class="col-12">
                    <div class="bar-grouped-bars">
                      <div>
                          <div :key="ix" v-for="(column, ix) in m.options" :style="`background-color: ${column.color}; width:${(column.date_one)}%`" class="d-inline-block barra" :class="`barra-group-${legends.indexOf(column.options)}`">
                            <div :style="`color: ${column.color}`" class="porcentaje-stacked porcentaje">{{ column.date_one }}<span class="symbol">%</span></div>
                          </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </b-collapse>
          <b-button class="btn-read-more" v-if="groupData.length > 4" @click="openAll(kebabCase(pregunta_id))">{{ read_more }} <iconPlus v-if="!open" /><iconMinus v-if="open" /></b-button>

        </div>
      </div>
    </div>

    <customNote :pregunta-parent="preguntaParent" /> 
   
  </div>
</template>

<script>
  import customNote from '@/components/customNote.vue'
  import iconPlus from '@/components/iconPlus.vue'
  import iconMinus from '@/components/iconMinus.vue'
  import { kebabCase, maxBy, map, groupBy, orderBy, sortBy, uniq } from 'lodash'
  import * as d3 from 'd3'

  export default {
    name: 'barChartStackedGroup',
    props: {
      data: [],
      field: String,
      preguntaParent: Object
    },
    components: {
      customNote,
      iconPlus,
      iconMinus
    },
    data() {
      return {
        read_more: `Leer todas las respuestas`,
        open: false
      }
    },
    computed: {
      color() {
        return ['#a50f15','#de2d26','#fc9272','#fcbba1','#fee5d9']
      },
      fullColumns() {
        return map(this.columns, (d, ix) => {
          return {
            column: d,
            color: this.color[ix]
          }
        })
      },
      pregunta_id() {
        return `pregunta-container-${uniq(map(this.data, 'question_id'))}`
      },
      groupData() {
        return sortBy(map(groupBy(this.data, 'groupby'), (items, groupby_value) => {
          return {
            groupby: groupby_value,
            options: orderBy(items, ['date_one'], ['desc'])
          }
        }), ['groupby'], ['asc']) 
      },
      legends() {
        return sortBy(uniq(map(this.data, 'options')))
      }
    },
    methods: {
      kebabCase,
      openAll(id) {
        this.$root.$emit('bv::toggle::collapse', id)
        this.open = !this.open
        this.read_more = !this.open ? `Leer todas las respuestas` : `Mostrar menos respuestas`
      },
      CalcularBarra(porcentaje) {
        let max = maxBy(this.data, "date_one")
        let scale = d3.scaleLinear().domain([0, max.date_one]).range([0, 100])
        return scale(parseInt(porcentaje))
      }
    }
  }
</script>